module.exports = __webpack_public_path__ + "static/media/banner_img.f1f6cd3f.png";